import React from "react";

import { Overlay } from "../";

import "./style.scss";
import useTranslate from "../../../translate/useTranslate";

const ConfirmDialog = function ({ txt, isVisible, onExit }) {
  const { t } = useTranslate();
  return (
    <Overlay
      visibility={isVisible ? "visible" : "hidden"}
      needExit
      exit={onExit}
      styleContainer={{ width: "80%" }}
    >
      <div className="confirm-dialog">
        <p>{txt}</p>
        <div className="action">
          <button className="btn btn-default" onClick={() => onExit(false)}>
            {t("Cancel")}
          </button>
          <button className="btn btn-green" onClick={() => onExit(true)}>
            {t("Yes")}
          </button>
        </div>
      </div>
    </Overlay>
  );
};

export default ConfirmDialog;
